import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const removeEmergentBadge = () => {
  document.getElementById("emergent-badge")?.remove();
};

removeEmergentBadge();

const badgeObserver = new MutationObserver(() => {
  removeEmergentBadge();
});

badgeObserver.observe(document.documentElement, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
